export default {
    axisDefaults: Object,
    categoryAxis: Array | Object,
    chartArea: Object,
    data: Array,
    dataSource: Object,
    autoBind: Boolean,
    plotArea: Object,
    pointWidth: Number,
    renderAs: String,
    series: Array,
    seriesColors: Array,
    seriesDefaults: Object,
    theme: String,
    tooltip: Object,
    transitions: Boolean,
    type: String,
    valueAxis: Array | Object,

    // Events
    axisLabelClick: Function,
    dataBound: Function,
    dragStart: Function,
    drag: Function,
    dragEnd: Function,
    plotAreaClick: Function,
    seriesClick: Function,
    seriesHover: Function,
    zoomStart: Function,
    zoom: Function,
    zoomEnd: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/SparklineProps.js